
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useCart } from '../../contexts/CartContext';

const Header = () => {
  const { user, isGuest, logout } = useAuth();
  const { totalItems } = useCart();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <header className="bg-[#0D47A1] text-white sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-4">
        {/* Top Bar */}
        <div className="hidden md:flex items-center justify-between py-2 text-sm border-b border-white/20">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1">
              <i className="ri-phone-line"></i>
              920000000
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-mail-line"></i>
              info@alomran.sa
            </span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/track-order" className="hover:text-[#FF8F00] transition-colors">
              تتبع طلبك
            </Link>
            <Link to="/quote-request" className="hover:text-[#FF8F00] transition-colors">
              طلب عرض سعر
            </Link>
          </div>
        </div>

        {/* Main Header */}
        <div className="flex items-center justify-between py-4 gap-4">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
              <span className="text-[#0D47A1] font-bold text-xl">ع</span>
            </div>
            <div className="hidden sm:block">
              <h1 className="font-bold text-xl">متجر العمران</h1>
              <p className="text-xs text-white/80">للأجهزة والتجهيزات</p>
            </div>
          </Link>

          {/* Search Bar */}
          <form onSubmit={handleSearch} className="flex-1 max-w-xl hidden md:block">
            <div className="relative">
              <input
                type="text"
                placeholder="ابحث عن منتجات، ماركات، أقسام..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full py-3 px-4 pr-12 rounded-lg text-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF8F00]"
              />
              <button type="submit" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-[#0D47A1] cursor-pointer">
                <i className="ri-search-line text-xl"></i>
              </button>
            </div>
          </form>

          {/* Actions */}
          <div className="flex items-center gap-3">
            {/* Cart */}
            <Link to="/cart" className="relative p-2 hover:bg-white/10 rounded-lg transition-colors cursor-pointer">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-shopping-cart-2-line text-2xl"></i>
              </div>
              {totalItems > 0 && (
                <span className="absolute -top-1 -left-1 w-5 h-5 bg-[#FF8F00] rounded-full text-xs flex items-center justify-center font-bold">
                  {totalItems}
                </span>
              )}
            </Link>

            {/* User Menu */}
            <div className="relative">
              <button
                onClick={() => setShowUserMenu(!showUserMenu)}
                className="flex items-center gap-2 p-2 hover:bg-white/10 rounded-lg transition-colors cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-user-line text-2xl"></i>
                </div>
                <span className="hidden sm:block text-sm">
                  {user ? user.name : isGuest ? 'زائر' : 'حسابي'}
                </span>
              </button>

              {showUserMenu && (
                <div className="absolute left-0 top-full mt-2 w-48 bg-white rounded-lg shadow-xl py-2 text-gray-800 z-50">
                  {user ? (
                    <>
                      <Link to="/profile" className="block px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => setShowUserMenu(false)}>
                        <i className="ri-user-line ml-2"></i>
                        حسابي
                      </Link>
                      <Link to="/orders" className="block px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => setShowUserMenu(false)}>
                        <i className="ri-file-list-3-line ml-2"></i>
                        طلباتي
                      </Link>
                      <hr className="my-2" />
                      <button
                        onClick={() => { logout(); setShowUserMenu(false); navigate('/'); }}
                        className="w-full text-right px-4 py-2 hover:bg-gray-100 text-red-600 cursor-pointer"
                      >
                        <i className="ri-logout-box-line ml-2"></i>
                        تسجيل الخروج
                      </button>
                    </>
                  ) : isGuest ? (
                    <>
                      <Link to="/orders" className="block px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => setShowUserMenu(false)}>
                        <i className="ri-file-list-3-line ml-2"></i>
                        طلباتي
                      </Link>
                      <hr className="my-2" />
                      <Link to="/login" className="block px-4 py-2 hover:bg-gray-100 text-[#0D47A1] cursor-pointer" onClick={() => setShowUserMenu(false)}>
                        <i className="ri-login-box-line ml-2"></i>
                        تسجيل الدخول
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link to="/login" className="block px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => setShowUserMenu(false)}>
                        <i className="ri-login-box-line ml-2"></i>
                        تسجيل الدخول
                      </Link>
                      <Link to="/register" className="block px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => setShowUserMenu(false)}>
                        <i className="ri-user-add-line ml-2"></i>
                        حساب جديد
                      </Link>
                    </>
                  )}
                </div>
              )}
            </div>

            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setShowMobileMenu(!showMobileMenu)}
              className="md:hidden p-2 hover:bg-white/10 rounded-lg transition-colors cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${showMobileMenu ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Navigation */}
        <nav className="hidden md:block border-t border-white/20">
          <ul className="flex items-center gap-1 py-2">
            <li>
              <Link to="/" className="px-4 py-2 rounded-lg hover:bg-white/10 transition-colors block cursor-pointer">
                الرئيسية
              </Link>
            </li>
            <li>
              <Link to="/categories" className="px-4 py-2 rounded-lg hover:bg-white/10 transition-colors block cursor-pointer">
                الأقسام
              </Link>
            </li>
            <li>
              <Link to="/categories/home-appliances" className="px-4 py-2 rounded-lg hover:bg-white/10 transition-colors block cursor-pointer">
                الأجهزة المنزلية
              </Link>
            </li>
            <li>
              <Link to="/categories/supermarket" className="px-4 py-2 rounded-lg hover:bg-white/10 transition-colors block cursor-pointer">
                تجهيزات السوبرماركت
              </Link>
            </li>
            <li>
              <Link to="/categories/projects" className="px-4 py-2 rounded-lg hover:bg-white/10 transition-colors block cursor-pointer">
                حلول المشاريع
              </Link>
            </li>
            <li>
              <Link to="/offers" className="px-4 py-2 rounded-lg bg-[#FF8F00] hover:bg-[#F57C00] transition-colors block cursor-pointer">
                العروض
              </Link>
            </li>
          </ul>
        </nav>

        {/* Mobile Menu */}
        {showMobileMenu && (
          <div className="md:hidden border-t border-white/20 py-4">
            <form onSubmit={handleSearch} className="mb-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="ابحث عن منتجات..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full py-3 px-4 pr-12 rounded-lg text-gray-800 text-sm focus:outline-none"
                />
                <button type="submit" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 cursor-pointer">
                  <i className="ri-search-line text-xl"></i>
                </button>
              </div>
            </form>
            <ul className="space-y-2">
              <li><Link to="/" className="block py-2 hover:text-[#FF8F00] cursor-pointer" onClick={() => setShowMobileMenu(false)}>الرئيسية</Link></li>
              <li><Link to="/categories" className="block py-2 hover:text-[#FF8F00] cursor-pointer" onClick={() => setShowMobileMenu(false)}>الأقسام</Link></li>
              <li><Link to="/categories/home-appliances" className="block py-2 hover:text-[#FF8F00] cursor-pointer" onClick={() => setShowMobileMenu(false)}>الأجهزة المنزلية</Link></li>
              <li><Link to="/categories/supermarket" className="block py-2 hover:text-[#FF8F00] cursor-pointer" onClick={() => setShowMobileMenu(false)}>تجهيزات السوبرماركت</Link></li>
              <li><Link to="/categories/projects" className="block py-2 hover:text-[#FF8F00] cursor-pointer" onClick={() => setShowMobileMenu(false)}>حلول المشاريع</Link></li>
              <li><Link to="/offers" className="block py-2 text-[#FF8F00] cursor-pointer" onClick={() => setShowMobileMenu(false)}>العروض</Link></li>
              <li><Link to="/track-order" className="block py-2 hover:text-[#FF8F00] cursor-pointer" onClick={() => setShowMobileMenu(false)}>تتبع طلبك</Link></li>
              <li><Link to="/quote-request" className="block py-2 hover:text-[#FF8F00] cursor-pointer" onClick={() => setShowMobileMenu(false)}>طلب عرض سعر</Link></li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
